import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ArrowLeft } from "@phosphor-icons/react";
import { EmployeeDetailsForm, emptyDetails, validateDetails } from "@/components/hr/EmployeeDetailsForm";

export default function NewEmployee() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState(emptyDetails);
  const [saving, setSaving] = useState(false);
  const back = user?.role === "admin" ? "/hrms" : "/my-hrms";

  const save = async () => {
    const err = validateDetails(f, user?.role);
    if (err) { toast.error(err); return; }
    setSaving(true);
    try {
      const { data } = await api.post("/salary/employees", { ...f, name: f.name.trim(), email: f.email.trim() });
      toast.success("Employee created — now upload documents");
      nav(`/hr/employees/${data.id}`);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="page-shell space-y-6 max-w-4xl" data-testid="new-employee-page">
      <div>
        <Link to={back} className="text-[12px] text-muted-foreground inline-flex items-center gap-1 hover:text-foreground" data-testid="new-emp-back"><ArrowLeft size={12} /> HRMS → Employees</Link>
        <div className="eyebrow mt-2">Step 1 of 7 · Create New Employee</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-1">Step 2: Employee Details</h1>
        <p className="text-sm text-muted-foreground mt-1">After saving you'll upload documents, add family contacts and set salary on the employee profile.</p>
      </div>
      <div className="card-flat p-5"><EmployeeDetailsForm f={f} setF={setF} /></div>
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={() => nav(back)}>Cancel</Button>
        <Button onClick={save} disabled={saving} data-testid="new-emp-save">Save & Continue to Documents</Button>
      </div>
    </div>
  );
}
